import { GroupInfo } from '@descomplica/dex-models';

export interface GroupState {
  groups: { [key: string]: GroupInfo };
}

const state: GroupState = {
  groups: {},
};

export default state;
